
import { Component, MixedVue } from "@/vue";
import { Prop } from "vue-property-decorator";

@Component({
  name: "Popup",
})
export default class Popup extends MixedVue {
  $props: {
    showOverlay?: boolean;
    showCloseIcon?: boolean;
    position?: "top" | "middle" | "bottom";
  };

  @Prop({ type: Boolean, default: false })
  showOverlay: boolean;

  @Prop({ type: Boolean, default: false })
  showCloseIcon: boolean;

  @Prop({ type: String, default: "middle" })
  position: "top" | "middle" | "bottom";

  showPopup = false;

  mounted() {
    this.showPopup = true;
  }

  dismissPopup() {
    this.showPopup = false;
  }
}
